module.exports = __webpack_public_path__ + "static/media/ji2.f1126eda.png";